import type { MemoryItem, Message } from "../types/app";

export function selectRelevantMemories(memories: MemoryItem[], userText: string, limit = 8): MemoryItem[] {
  const terms = new Set(
    userText
      .toLowerCase()
      .split(/[\s、。,.!?！？「」()（）]+/)
      .filter((term) => term.length >= 2),
  );
  const scored = memories
    .filter((memory) => memory.category !== "temporary" || memory.isPinned)
    .map((memory) => {
      const haystack = memory.content.toLowerCase();
      let score = memory.isPinned ? 100 : memory.importance;
      terms.forEach((term) => {
        if (haystack.includes(term)) score += 4;
      });
      if (memory.category === "pinned") score += 30;
      return { memory, score };
    })
    .sort((a, b) => b.score - a.score);
  return scored.slice(0, limit).map((item) => item.memory);
}

export function recentConversation(messages: Message[], limit = 8): Pick<Message, "role" | "content">[] {
  return messages.slice(-limit).map(({ role, content }) => ({ role, content }));
}
